export default "__VITE_ASSET__8exG5auB__ 100w, __VITE_ASSET__BfWwX8GO__ 200w, __VITE_ASSET__B7wEdwEW__ 300w";